import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import utils from '../../utils/utils';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import apiCalls from '../../utils/apiCalls';

const AdminCtaGroupRow = ({ ctaGroup, getCtaGroups, intl }) => {
  function deleteBill() {
    const confirmMessage = intl.formatMessage({ id: 'cta.group.view.delete.confirm' });

    if (window.confirm(confirmMessage)) {
      apiCalls
        .deleteCtaGroups(ctaGroup.id)
        .then(() => {
          getCtaGroups();
        })
        .catch((errors) => {
          window.alert(utils.getErrorMessageFromResponse(errors, true));
        });
    }
  }

  const { formatMessage } = useIntl();

  return (
    <tr>
      <th scope="row">{ctaGroup.id}</th>
      <td>{ctaGroup.title}</td>
      <td>{ctaGroup.description}</td>
      <td>
        <FormattedMessage id={`cta.group.form.field.type.name.${ctaGroup.type}`} />
      </td>
      <td>
        {ctaGroup.ctaGroups.map((ctaGroup) => (
          <div>{`${ctaGroup.title} - #${ctaGroup.id}`}</div>
        ))}
      </td>
      <td>
        {ctaGroup.items.map((item) => (
          <div>{`${utils.getItemName(item, formatMessage)} - #${item.id}`}</div>
        ))}
      </td>
      <td>
        {ctaGroup.marketplaces.map((marketplace) => (
          <div>{`${marketplace.name} - #${marketplace.id}`}</div>
        ))}
      </td>
      <td>
        {ctaGroup.itemCollections.map((ic) => (
          <div>{`${ic.name} - #${ic.id}`}</div>
        ))}
      </td>
      <td>
        <Link to={`/admin/ctaGroups/edit/${ctaGroup.id}`} className="link">
          Edit
        </Link>
        <br />
        <button className="btn btn-normal-link" onClick={deleteBill}>
          Delete
        </button>
      </td>
    </tr>
  );
};

AdminCtaGroupRow.propTypes = {
  ctaGroup: PropTypes.object.isRequired,
  getCtaGroups: PropTypes.func.isRequired,
};

AdminCtaGroupRow.defaultProps = {};

export default injectIntl(AdminCtaGroupRow);
